module.exports = __webpack_public_path__ + "img/大赛信息@2x.b426d9b6.png";